import { render, staticRenderFns } from "./DialogAddVademecum.vue?vue&type=template&id=e9ea3ce0&scoped=true&"
import script from "./DialogAddVademecum.vue?vue&type=script&lang=js&"
export * from "./DialogAddVademecum.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddVademecum.vue?vue&type=style&index=0&id=e9ea3ce0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ea3ce0",
  null
  
)

export default component.exports